import { createAction, props } from '@ngrx/store';

export const subscribeToProvisionLogData = createAction(
    '[Data Import] Subscribe To Provision Log Data',
    props<{ tenantId: number, userId: number }>()
);

export const clearProvisionLogData = createAction(
    '[Data Import] Clear Provision Log Data',
    props<{ state: any[] }>()
);